import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/carbon-footprint-calculator',
  component: () => import('../../routes/CarbonFootprintCalculator.svelte'),
  card: {
    id: 'carbon-footprint-calculator',
    title: 'Carbon Footprint Calculator',
    description: 'Estimate your annual carbon footprint across home energy, transportation, diet, and lifestyle. Learn how to reduce your environmental impact.',
    icon: 'eco',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/carbon-footprint-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Carbon Footprint Calculator – Estimate Your Annual CO2 Emissions',
    description: 'Free carbon footprint calculator. Estimate annual CO2e from home energy, transportation, diet, and consumer goods. See offset recommendations and year-by-year projections.',
  },
};

export default meta;
